<template>
  <ui-box label="Uložené publikum">
    <v-select
      :items="audiencesList"
      item-text="name"
      item-value="id"
      outlined
      hide-details
      placeholder="Zvolte jedno z vašich uložených publik"
      v-model="audienceId"
      @input="onInput"
    />
  </ui-box>
</template>

<script>
import { call, get, sync } from "vuex-pathify"
import store from "@/store"

export default {
  props: {
    audienceType: String,
    storeNamespace: String,
  },
  data() {
    return {
      audienceId: null,
    }
  },
  computed: {
    ...get("audiences", ["audienceDrafts"]),
    ...sync("audiences@model", ["audience"]),
    audiencesList() {
      return this.audienceDrafts.filter(
        i => i.id && i.audienceType === this.audienceType
      )
    },
  },
  methods: {
    ...call("audiences", ["loadAudienceDrafts"]),
    onInput() {
      const draft = this.audienceDrafts.find(
        item => item.id === this.audienceId
      )
      draft.audienceSubType = "saved"
      store.commit(`${this.storeNamespace}/SET_MODEL_AUDIENCE`, draft)
    },
  },
  mounted() {
    this.loadAudienceDrafts()
  },
}
</script>
